<template>
    <div class="notification">
        <Popup mode="notification" :open="isOpen" @closePopup="resetNotification">
            {{notification}}
        </Popup>
    </div>
</template>

<script>
    import CloseIcon from "@/assets/icons/close.svg"
    import Popup from "@/components/popup/Popup";
    import {mapState} from "vuex";
	export default {
		computed: {
			...mapState('vorbasse', {
				notification: 'notification'
			}),
			isOpen(){
				return this.notification !== ''
			}
		},
		methods: {
			resetNotification(){
				this.$store.commit('vorbasse/setNotification','')
			}
		},
        components: {
	        Popup,
	        CloseIcon
        }
	}
</script>

<style lang="scss" scoped>
	.notification{
		position:fixed;
		z-index:50;
	}
</style>
